import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { DeprecatedInput } from '../../primitives/deprecated-input/input';
/** @deprecated please use \<FormControl/> */
var FormInput = /** @class */ (function (_super) {
    __extends(FormInput, _super);
    function FormInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormInput.prototype.render = function () {
        var _a = this.props, validationError = _a.validationError, props = __rest(_a, ["validationError"]);
        var invalid = !!validationError;
        var classNames = namespacedClassnames('form-input', { invalid: invalid }, props.className);
        var maybeInvalidMsg = invalid ? (React.createElement("div", { className: 'validation-msg' }, validationError)) : null;
        return props.label ? (React.createElement("label", { className: classNames },
            React.createElement("span", { className: 'label-text' }, props.label),
            React.createElement(DeprecatedInput, __assign({}, props)),
            maybeInvalidMsg)) : (React.createElement("span", { className: classNames },
            React.createElement(DeprecatedInput, __assign({}, props)),
            maybeInvalidMsg));
    };
    return FormInput;
}(React.PureComponent));
export { FormInput };
//# sourceMappingURL=form-input.comp.js.map